<template>
    <div v-if="globalState.blocked" class="global-loader">
        <v-progress-circular :size="64" color="ms-orange" indeterminate class="spinner"></v-progress-circular>
        <img :src="iconDark" alt="logo" class="callout-logo" />
    </div>
</template>
<script>
import { useGlobalState } from '@/stores/globalState';
import iconDark from '@/assets/images/icon_dark.png';
export default {
    setup() {
        return {
            globalState: useGlobalState(),
        }
    },
    data() {
        return {
            iconDark,
        }
    }
};
</script>
<style scoped>
.global-loader {
    height: 100vh;
    width: 100vw;
    background: rgba(255, 255, 255, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
}

.global-loader .spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 12;
}

.global-loader .callout-logo {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5rem;
    opacity: 0.8;
    transition: 0.3s ease-in-out;
}
</style>
